
/**
 * src/pages/About.jsx
 */
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function About() {
  return (
    <div>
      <Helmet>
        <title>About Us | Ritu Fashion Store, Gurgaon</title>
        <meta
          name="description"
          content="Since 1996, Ritu Fashion Store in Gurgaon has been making kids' shopping easy with carefully curated collections, premium quality, and designs from the best Indian brands."
        />
      </Helmet>

      <img
        src="/store-inside-image.png"
        alt="Ritu Fashion Store"
        width={1600}
        height={1008}
        style={{
          width: "100%",
          height: "38vh",
          minHeight: 240,
          objectFit: "cover",
        }}
      />

      <div className="container-sm section">
        <h1 style={{ fontSize: "2rem", fontWeight: 800 }}>Our Story</h1>

        <p
          className="muted mt-6"
          style={{ fontSize: "1.125rem", lineHeight: 1.7 }}
        >
          Ritu Fashion Store began its journey in Gurgaon in 1996 with a
          simple belief — shopping for children should be easy, enjoyable, and
          full of smiles. Over the years, we have grown with generations of
          families, carefully bringing together everything parents need to
          make their little ones' wardrobes stylish, comfortable, and special.
        </p>

        <p
          className="muted mt-4"
          style={{ fontSize: "1.125rem", lineHeight: 1.7 }}
        >
          Our goal is to create an inclusive one-stop destination for all the
          needs and little luxuries of children. We want to make kids'
          shopping a child's play for contemporary parents, so you can spend
          less time searching and more time enjoying those precious moments
          with your little ones.
        </p>

        <p
          className="muted mt-4"
          style={{ fontSize: "1.125rem", lineHeight: 1.7 }}
        >
          Every collection at Ritu Fashion Store is thoughtfully and
          selectively curated from some of the best Indian brands. We look
          for premium fabrics, excellent quality, beautiful designs, and
          pieces that children will love to wear. We never compromise on
          comfort or quality because we believe your little ones deserve the
          very best.
        </p>

        <div
          style={{
            display: "grid",
            gap: "1.5rem",
            gridTemplateColumns:
              "repeat(auto-fit, minmax(180px, 1fr))",
            marginTop: "3rem",
          }}
        >
          {[
            {
              t: "Curated Collections",
              d: "A highly selective and exclusive collection of kidswear, thoughtfully chosen to make dressing your little ones effortless.",
            },
            {
              t: "Premium Quality",
              d: "We choose the best fabrics and quality materials, paired with premium designs that look as good as they feel.",
            },
            {
              t: "Made for Kids",
              d: "Comfort, style and practicality come together in collections designed around the needs of growing children.",
            },
          ].map((c) => (
            <div
              key={c.t}
              className="card"
              style={{
                background: "var(--secondary)",
                padding: 24,
              }}
            >
              <h2 style={{ fontSize: "1.125rem", fontWeight: 700 }}>
                {c.t}
              </h2>
              <p
                className="muted mt-2"
                style={{ fontSize: 14 }}
              >
                {c.d}
              </p>
            </div>
          ))}
        </div>

        <div className="card mt-8" style={{ padding: 24 }}>
          <h2 style={{ fontSize: "1.25rem", fontWeight: 700 }}>
            Come say hello
          </h2>
          <p className="muted mt-2">
            Visit us at 157/13, Sadar Bazar Rd, Roshan Pura, Gurugram,
            Haryana 122007 · Open Monday to Sunday, 10am to 9pm.
          </p>
          <Link to="/contact" className="btn btn-primary mt-4">
            Contact us
          </Link>
        </div>
      </div>
    </div>
  );
}
